import { PType } from './aui'
import * as React from 'react'
import { connect } from 'react-redux'
import { IDetailPageState } from '../reducers'
import { Logger } from 'DVWebNodeUtils'
import { refreshMainActionBox, refreshEpisode } from '../actions/wps'
import { playbackIdToCanonicalIdSelector } from '../selectors/player'
import { isMovieSelector } from '../selectors/detailFragment'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { PlayerContentConfig } from './playerIntegration'

export type PrepareConfig = {
  trailer?: boolean
  ref?: string
  videoType?: string
  asin: WpsRuntime.atv.wps.TitleID
  position?: number
  useFullView: boolean
}

export interface Player {
  on: (event: string, callback: (_?: PlayerContentConfig) => void) => void
  play: () => void
  prepare: (config: PrepareConfig) => void
}

declare let window: Window & { P: PType }

export interface PlayerCapabilities {
  supportsWebPlayback: boolean
  supportsHDMovies: boolean
}

interface PlayerCapabilitiesWrapper {
  capabilities: PlayerCapabilities
}

export const onPlayerCapabilities = (
  callback: (capabilities: PlayerCapabilities) => void,
  logger: Logger
) => {
  if (!window.P) {
    logger.error('P is missing')
    return
  }
  window.P.when('dv-web-player-capabilities').execute(
    (
      onCapabilities: (
        callback: (pc: PlayerCapabilitiesWrapper) => void
      ) => void
    ) => {
      onCapabilities(pc => {
        if (pc && pc.capabilities) {
          callback(pc.capabilities)
        }
      })
    }
  )
}

type PlayerIntegrationConnectedProps = ReturnType<typeof mapStateToProps>
export class PlayerIntegrationConnected extends React.Component<
  PlayerIntegrationConnectedProps
> {
  attachRefreshEventHandlers() {
    const handlePlayerClosedOrTitleChanged = (opts?: PlayerContentConfig) => {
      if (opts && !opts.trailer && opts.asin) {
        const { canonicalTitleIdMap, pageTitleId, isMovie } = this.props
        const canonicalTitleId =
          (canonicalTitleIdMap && canonicalTitleIdMap[opts.asin]) || opts.asin
        refreshMainActionBox(pageTitleId, canonicalTitleId, canonicalTitleId)
        if (!isMovie) {
          refreshEpisode(canonicalTitleId)
        }
      }
    }

    if (window.P) {
      window.P.when('dv-player-integration').execute((auiPlayer: Player) => {
        auiPlayer.on('closed', handlePlayerClosedOrTitleChanged)
        auiPlayer.on('asinChanged', handlePlayerClosedOrTitleChanged)
      })
    }
  }

  componentDidMount() {
    this.attachRefreshEventHandlers()
  }

  render(): null {
    return null
  }
}

const mapStateToProps = (state: IDetailPageState) => ({
  pageTitleId: state.pageTitleId,
  canonicalTitleIdMap: playbackIdToCanonicalIdSelector(state),
  isMovie: isMovieSelector(state),
})

export const PlayerIntegrationAui = connect(mapStateToProps)(
  PlayerIntegrationConnected
)
